// extracted by mini-css-extract-plugin
export var cell = "_58-4";
export var headerCell = "_58-2";
export var rowHeader = "_58-3";
export var table = "_58-1";
export var tableContainer = "_58-0";